// A tiny shared store: the hero publishes its player, document and the governor's decisions;
// the sections below (binary, export, governor) read them.
import { useEffect, useState } from 'react';

const state = {
  Pulse: null,
  player: null,
  doc: null,
  counts: null,
  stress: 1,
  fx: null,
  audioUrl: null,
  events: [], // governor 'quality' events, newest first
  perf: null,
};
const subs = new Set();

export const heroStore = {
  get: () => state,
  set(patch) {
    Object.assign(state, patch);
    for (const fn of subs) fn(state);
  },
  subscribe(fn) {
    subs.add(fn);
    return () => subs.delete(fn);
  },
};

/** Re-render when the store changes (optionally only when select(state) changes). */
export function useHero(select = (s) => s) {
  const [v, setV] = useState(() => select(state));
  useEffect(() => heroStore.subscribe((s) => setV(() => select(s))), []); // eslint-disable-line react-hooks/exhaustive-deps
  return v;
}
